import { ReactNode } from "react";
import Button from "@Components/Button";
import styles from "./tabs.module.scss";
import wrapperHOC from "@Utils/wrapperHOC";

type TabTypes = {
  value: string;
  children: ReactNode;
  setActiveTab?: any;
  activeTab?: string;
  className?: any;
  onClick?: () => void;
  dataTestId?: string;
  id?: string;
  withoutBorder?: boolean;
  scrollToEnd?: (val: string) => void;
};

const Tab = ({
  value,
  children,
  className = "",
  onClick,
  dataTestId,
  id,
  withoutBorder = false,
  ...rest
}: TabTypes) => {
  const isActive = value === rest?.activeTab;

  const handleOnClick = () => {
    if (rest?.setActiveTab) {
      rest?.setActiveTab(value);
      rest?.scrollToEnd?.(value);
    }
    if (onClick) {
      onClick();
    }
  };

  return (
    <Button
      className={`${styles.tab} ${className} ${withoutBorder ? styles.withoutBorder : ""} ${
        isActive ? styles.active : ""
      }`}
      variant="outline"
      onClick={handleOnClick}
      role="tab"
      isSelected={isActive}
      dataTestId={dataTestId}
      id={id}
    >
      {children}
    </Button>
  );
};

export default wrapperHOC(Tab, {
  componentName: "Tab-Tabs-Global",
  showForChina: true,
});
